'use client';

import { HStack, Box } from '@terra/ui-styled-system';
import { BodyStrong, MetaDefault } from '../../components/typography';
import { Link } from '../../components/link';

export type BreadcrumbItem = {
  title: string;
  href: string;
  onClick?: () => void;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  if (items.length === 0) return null;

  return (
    <HStack alignItems="center" gap={2} minW={0} overflow="hidden" w="full">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const segment =
          item.onClick && !isLast ? (
            <Box
              as="button"
              onClick={item.onClick}
              fontSize="sm"
              color="fg.muted"
              minW={0}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              display="block"
              bg="transparent"
              border="none"
              cursor="pointer"
              _hover={{
                color: 'fg.default',
              }}
            >
              {item.title}
            </Box>
          ) : item.href && !isLast ? (
            <Link
              href={item.href}
              textDecoration="none"
              minW={0}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              display="block"
              _hover={{
                textDecoration: 'none',
              }}
            >
              <MetaDefault
                as="span"
                display="block"
                color="fg.muted"
                _hover={{ color: 'fg.default' }}
              >
                {item.title}
              </MetaDefault>
            </Link>
          ) : (
            <BodyStrong
              minW={0}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              display="block"
            >
              {item.title}
            </BodyStrong>
          );
        return (
          <HStack
            key={index}
            alignItems="center"
            gap={2}
            minW={0}
            overflow="hidden"
            flexShrink={1}
          >
            {segment}
            {!isLast && (
              <Box
                w="1px"
                h="14px"
                bg="border.default"
                flexShrink={0}
                aria-hidden
              />
            )}
          </HStack>
        );
      })}
    </HStack>
  );
};
